import { ImageLoaderProps } from "next/image";
import { getConfig } from "../_configs/AppConfig";

const DEFAULT_WEBP_QUALITY = 75;

// Routes next/image requests through the Serverless Image Handler instead of
// Next's built-in sharp-based optimizer, so resizing/encoding happens off our
// app servers and the result is cached by CloudFront.
export function nextImageLoader({
  src,
  width,
  quality,
}: ImageLoaderProps): string {
  const { publicRuntimeConfig } = getConfig();
  const { APP_ENV, MEDIA_CDN_URL, IMAGE_HANDLER_URL, S3_MEDIA_BUCKET } =
    publicRuntimeConfig;

  // MEDIA_CDN_URL is "" for test on purpose (see getCdnUrl), which would
  // otherwise make `src.startsWith(MEDIA_CDN_URL)` vacuously true for every
  // src and route it through the real image handler anyway.
  if (APP_ENV === "test") return src;
  if (!src.startsWith(MEDIA_CDN_URL)) return src;

  const key = src.slice(MEDIA_CDN_URL.length).replace(/^\//, "");
  const payload = JSON.stringify({
    bucket: S3_MEDIA_BUCKET,
    key,
    edits: {
      resize: { width, fit: "inside", withoutEnlargement: true },
      webp: { quality: quality ?? DEFAULT_WEBP_QUALITY },
    },
  });

  return `${IMAGE_HANDLER_URL}/${Buffer.from(payload).toString("base64")}`;
}
